import { useEffect } from "react";

type SeoConfig = {
  title: string;
  description: string;
  keywords: string;
  path: string;
  type?: string;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
};

const SITE_NAME = "诱惑吃瓜";
const SITE_ORIGIN = "https://benpr.cn";

const setMeta = (attr: "name" | "property", key: string, content: string) => {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setLink = (rel: string, href: string) => {
  let el = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export const usePageSeo = ({ title, description, keywords, path, type = "website", jsonLd }: SeoConfig) => {
  useEffect(() => {
    const url = `${SITE_ORIGIN}${path}`;
    document.title = title;
    document.documentElement.lang = "zh-CN";

    setMeta("name", "description", description);
    setMeta("name", "keywords", keywords);
    setMeta("name", "robots", "index, follow, max-image-preview:large");
    setMeta("name", "author", SITE_NAME);
    setMeta("property", "og:site_name", SITE_NAME);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", type);
    setMeta("property", "og:url", url);
    setMeta("property", "og:locale", "zh_CN");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setLink("canonical", url);

    const existing = document.getElementById("page-json-ld");
    if (existing) existing.remove();
    if (jsonLd) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "page-json-ld";
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }

    return () => {
      const script = document.getElementById("page-json-ld");
      if (script) script.remove();
    };
  }, [title, description, keywords, path, type, jsonLd]);
};

export { SITE_NAME, SITE_ORIGIN };